export { default } from './GridEventCategories.vue'
